var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import chartUtils from '../../../utils/chart-utils';
import buildSeriesData from '../buildData';
import configureTooltip from '../tooltip/main';

var seriesName = 'Packed Bubble';
var seriesType = 'packedbubble';

var buildPackedBubbleConfiguration = function buildPackedBubbleConfiguration(bubbleConfig, seriesConfig, seriesDataObj, customConfig) {
	var DisplayCount = bubbleConfig.DisplayCount;

	var limit = parseInt(DisplayCount) || seriesDataObj[seriesName].length;

	var CrumbFieldName = bubbleConfig.CrumbFieldName,
	    CrumbDisplayFieldName = bubbleConfig.CrumbDisplayFieldName,
	    ValueFormat = bubbleConfig.ValueFormat,
	    BaseFormat = bubbleConfig.BaseFormat,
	    CurrencySymbol = bubbleConfig.CurrencySymbol,
	    ShowLabels = bubbleConfig.ShowLabels,
	    FormatConfig = bubbleConfig.FormatConfig,
	    AreaNameField = bubbleConfig.AreaNameField,
	    AreaValueField = bubbleConfig.AreaValueField;


	var seriesArray = seriesDataObj[seriesName];

	var data = buildSeriesData(seriesArray, AreaNameField, AreaValueField, CrumbFieldName, CrumbDisplayFieldName, limit, FormatConfig, seriesConfig);

	return merge({
		name: data[AreaNameField],
		type: seriesType,
		colorByPoint: true,
		useSimulation: false,
		data: data,
		dataLabels: {
			enabled: true,
			formatter: function formatter() {
				if (ShowLabels) {
					if (ValueFormat == '%') ValueFormat = '.0%';
					return chartUtils.format(this.y, ValueFormat, CurrencySymbol, null, BaseFormat);
				}

				return this.point[AreaNameField];
			}
		},
		tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
	}, customConfig);
};

export default buildPackedBubbleConfiguration;